import styles from "./PreViewMapType.module.css";
import emapView from "../../img/emap_view.jpg";
import streetmapView from "../../img/streetmap_view.jpg";
import umapView from "../../img/umap_view.jpg";
interface MapPreviewProps {
    mapType: string;
}

/**
 * @author cjs
 * @date 2024-09-27 10:26:02
 * @remark 지도만들기 지도 종류 설정 미리보기 화면 컴포넌트
 * @pram props
 * @props MapPreviewProps
 *      mapType(required) : 지도 종류
 */

function PreViewMapType(props: MapPreviewProps) {
    const render = () => {
        if (props.mapType === "baroEmap") {
            return <img className={styles.mapView} src={emapView} alt="바로e맵 미리보기" />;
        } else if (props.mapType === "OSM") {
            return <img className={styles.mapView} src={streetmapView} alt="Open Street Map 미리보기" />;
        }
    };
    return <div className={styles.wrapMapView}>{render()}</div>;
}
export default PreViewMapType;
